const sameLabelValueMapper = <T>(entity: T) => ({label: entity, value: entity});

export default sameLabelValueMapper;
